import {Component, HostListener, Input, OnInit} from '@angular/core';
import {MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';

import {AttributeEntity} from '@app/core/model/integration-models';

@Component({
    selector: 'ngc-piishield-confirm-dialog',
    templateUrl: './piishield-confirm-dialog.component.html',
    styleUrls: ['./piishield-confirm-dialog.component.scss']
})
export class PIIShieldConfirmDialogComponent implements OnInit {

    @Input() isPIIShieldApplied: boolean;
    @Input() piiShieldCouldBeApplied: boolean;
    @Input() piiShieldAttributesAbilityListCount: number;
    @Input() piiShieldAttributesDataMaskingListCount: number;
    @Input() piiShieldAttributesAbilityList: AttributeEntity[];
    @Input() PIIShieldRequiredAttributesAbilityList: AttributeEntity[];
    @Input() piiShieldAttributesDataMaskingList: AttributeEntity[];

    title: string;

    constructor(public dialogRef: MatDialogRef<PIIShieldConfirmDialogComponent>) { }

    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKeydownHandler(event: KeyboardEvent) {
        this.onClose('cancel');
    }

    ngOnInit() {
        this.title = this.isPIIShieldApplied ? 'Apply Privacy Shield' : 'Revert Privacy Shield changes';
    }

    onClose(result: 'cancel' | 'ok' | 'apply masking only') {
        this.dialogRef.close(result);
    }
}
